import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import { getAceiteTermos } from '../../../api/fastcoinService';

import toast, { Toaster } from 'react-hot-toast';
import ShowFieldGroupSEPA from '../../ShowFieldGroupSEPA';

const SEPA = (props) => {

    const { translate, lang, orderFromDeposit } = useLanguage();
    const country = sessionStorage.getItem("country").toLocaleLowerCase();
    let order_number = sessionStorage.getItem("order_no");

    useEffect(() => {

        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }
    }, []);


    useEffect(() => {
        translate();
    }, [translate, country]);


    const notify = () => {
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }
    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />

            <div className='row'>
                <div className='col-md-12'>
                    <ShowFieldGroupSEPA country={country} order_number={order_number}/>
                    <br />
                    <p className="center"><b>{getStrLang(lang.nameLang, "msg5_TED1") + " "}<span className="destaque-order">{order_number}</span> {" " + getStrLang(lang.nameLang, "msg5_SEPA")}</b></p>
                </div>
            </div>
        </>)
}

export default SEPA;